module.exports = __webpack_public_path__ + "static/media/fruits_43.0d2b1074.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_43.csv
// module id = 710
// module chunks = 0